import Icon from '@/components/ui/AppIcon';

export interface TimelineData {
  phase: string;
  duration: string;
  activities: string[];
  iconName: string;
}

export default function TimelineCard({ phase, duration, activities, iconName }: TimelineData) {
  return (
    <div className="bg-card border border-border rounded-xl p-6 hover:shadow-soft transition-all duration-300">
      <div className="flex items-start space-x-4 mb-4">
        <div className="flex-shrink-0 w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
          <Icon name={iconName as any} size={24} variant="outline" className="text-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="font-headline font-semibold text-lg text-foreground mb-1">{phase}</h4>
          <p className="text-sm text-muted-foreground font-body">{duration}</p>
        </div>
      </div>
      <ul className="space-y-2">
        {activities.map((activity, index) => (
          <li key={index} className="flex items-start space-x-2">
            <Icon name="CheckCircleIcon" size={16} variant="solid" className="text-success mt-0.5 flex-shrink-0" />
            <span className="text-sm text-foreground font-body">{activity}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}